var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 49,
    viewBox: "0 0 34 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6812 0.930197C14.5527 0.852057 14.5906 0.791712 14.6707 0.919215C15.6325 2.46705 17.9745 7.21206 15.371 10.5884C12.2239 14.6703 11.9167 13.0089 9.96443 15.7306C8.0122 18.4523 10.1343 19.312 8.55896 23.9311C6.98359 28.5502 1.28884 31.9953 2.03478 36.8466C2.7179 41.2819 6.44283 44.2901 10.6736 45.3611C15.0189 46.4618 19.8557 45.544 22.2848 41.8952C27.0807 34.6935 25.49 30.545 25.1735 26.753C24.8932 23.3956 28.1496 18.6701 30.5211 16.6859C30.6464 16.5813 30.6632 16.6239 30.5132 16.6852C28.5774 17.4854 24.5271 19.373 23.639 22.3062C22.4648 26.1787 20.9284 28.6381 20.7645 30.5469C20.694 25.2456 20.8879 23.3707 22.6695 20.1483C24.114 17.535 24.1826 13.1807 24.0805 11.6181C24.0712 11.4677 23.8534 11.4957 23.7919 11.6338C23.1425 13.1046 21.0393 17.1482 19.1053 18.6154C16.7369 20.4131 15.2044 31.8026 15.7184 33.1575C12.0997 27.3116 11.8754 26.3661 15.8482 20.1458C19.8211 13.9255 20.7567 8.23242 19.73 5.52294C18.925 3.39453 15.8739 1.65823 14.6812 0.930197Z",
    fill: "#F81958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61994 29.8497C8.61994 29.8497 4.32201 34.834 5.26321 38.0795C6.20441 41.325 9.80004 43.2953 12.7467 43.0287C15.6933 42.762 21.8264 39.7244 22.6705 36.7997C23.5145 33.8749 23.6521 31.2207 23.6521 31.2207C23.6521 31.2207 21.4484 36.1302 19.6272 36.7307C17.806 37.3313 18.9549 30.2449 18.9549 30.2449C18.9549 30.2449 18.2659 36.8312 15.118 36.6105C11.9702 36.3899 8.6307 33.4315 8.61994 29.8497Z",
    fill: "#E2EB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4568 14.0231C15.4568 14.0231 12.2868 16.4186 12.0845 18.3346C11.8823 20.2506 12.1493 22.5146 12.1493 22.5146C12.1493 22.5146 14.3289 20.1285 15.4568 14.0231Z",
    fill: "#E2EB76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8187,
    height: 44,
    fill: "white",
    transform: "translate(11.4756) rotate(15.118)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotFire);
export default __webpack_public_path__ + "static/media/hot_fire.8e78c74cbfdc4e135d519a3239fb0b15.svg";
export { ForwardRef as ReactComponent };